<template>
  <div class=wrapper>
    <div id=player class=player ref=player></div>
  </div>
</template>

<script>
import { db } from '@/config'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import { Player, PlayerEvent } from 'bitmovin-player/modules/bitmovinplayer-core';
// import BitmovinEngineModule from 'bitmovin-player/modules/bitmovinplayer-engine-bitmovin';
// import MSERendererModule from 'bitmovin-player/modules/bitmovinplayer-mserenderer';
// import HLSModule from 'bitmovin-player/modules/bitmovinplayer-hls';
// import DASH from 'bitmovin-player/modules/bitmovinplayer-dash';
// import DRM from 'bitmovin-player/modules/bitmovinplayer-drm'

// import ABRModule from 'bitmovin-player/modules/bitmovinplayer-abr';
// import TSContainerModule from 'bitmovin-player/modules/bitmovinplayer-container-ts';

// Player.addModule(BitmovinEngineModule);
// Player.addModule(MSERendererModule);
// Player.addModule(HLSModule);
// Player.addModule(DRM);
// Player.addModule(DASH)
// Player.addModule(ABRModule);
// Player.addModule(TSContainerModule);

export default {
  name: 'Video',
  data () {
    return {
      fromTimestamp: false,
      player: null,
      session: null,
      sessionRef: null,
      modalData: null,
      setupInit: null,
      pid: null,
      activePid: null,
      playingVideo: false,
      first_play_event: 'first_play'
    }
  },
  computed: {
    ...mapGetters(['program'])
  },
  async created () {
    this.fromTimestamp = this.$route.query.timestamp
    await this.getProgramBySlug(this.$route.params.slug)
    this.modalData = this.program
    this.init()

    window.addEventListener("beforeunload", (e) => {
      this.beforeExit()
      return true
    });
  },
  activated () {
    this.first_play_event = 'first_play'
  },
  methods: {
    ...mapActions(['getProgramBySlug', 'userData', 'log_video_views']),
    ...mapMutations(['setVideoBack']),
    setup () {
      console.log('Video', '{{setupInit}}', this.setupInit)
      console.log('Video', '{{user}}', this.$store.getters.user)
      console.log('Video', '{{this.modalData}}', this.modalData.slug, this.setupInit)
      console.log('Video', '{{this.player}}', this.player)

      const playerKey = 'c440e4ff-161b-41be-a873-968f37e42d4d'
      const analyticsKey = 'adf314a8-fe63-4c96-bbe8-d883996368d6'

      const bitmovin = {
        player: window.bitmovin.player.Player,
        playerEvent: window.bitmovin.player.PlayerEvent,
        event: {
          ON_PLAYING: window.bitmovin.player.PlayerEvent.Playing,
          ON_PAUSED: window.bitmovin.player.PlayerEvent.Paused,
          ON_DESTROY: window.bitmovin.player.PlayerEvent.Destroy
        }
      };

      if (this.setupInit) return;
      // if (this.player) return;
      this.modalData = this.modalData || this.program
      var user = this.$store.getters.user
      if (user == null) {
        this.$bvueUi.modal.close()
        console.log('Video', 'ERROR: trying to see video unregistered user')
        return
      }

      this.modalData.video.dash = this.modalData.video.dash
        .replace('https://storage.googleapis.com/planet-horror.appspot.com', 'https://cdn.planethorror.es')
      this.modalData.video.hls = this.modalData.video.hls
        .replace('https://storage.googleapis.com/planet-horror.appspot.com', 'https://cdn.planethorror.es')


      // this.modalData.video.hls = "https://bitmovin-a.akamaihd.net/content/playhouse-vr/mpds/105560.mpd"
      if (this.$route.query.vr) {
        this.modalData.video.dash = "https://cdn.microcanales.com/asset/2021-03-08-odisea_asignatura_empatia_sin_drm/manifest.mpd"
      }
      // this.modalData.video.dash = "https://bitmovin-a.akamaihd.net/content/playhouse-vr/mpds/105560.mpd"

      const poster = this.modalData.video.media && this.modalData.video.media.lg ? this.modalData.video.media.lg : this.modalData.video.poster

      const config = {
        key: playerKey,
        // ui: false,
        // style: {
        //   aspectratio: '1:1'
        // },
        style: {
          height: '100%',
          aspectratio: '16/9'
        },
        advertising: {},
        /*
        analytics: {
          key: analyticsKey,
          videoId: this.modalData.slug,
          title: this.modalData.video.master_file_name || 'filename',
          customData1: user.uid, // User id
          customData2: this.modalData.id, // Program id
          customData3: this.modalData.slug, // Program slug
          customData4: this.modalData.video.master_file_name || 'filename' // Filename
        }
        */
      }
      const source = {
        dash: this.modalData.video.dash,
        hls: this.modalData.video.hls,
        // progressive: 'https://bitmovin.com/player-content/playhouse-vr/progressive.mp4',
        poster: poster,
        drm: {
          widevine: {
            LA_URL: 'https://widevine-dash.ezdrm.com/proxy?pX=1512CB'
          },
          playready: {
            LA_URL: 'https://playready.ezdrm.com/cency/preauth.aspx?pX=2FAC2F'
          },
          fairplay: {
            LA_URL: 'https://fps.ezdrm.com/api/licenses/c9f95f2e-a5ec-4597-80f7-158ee920d5c6',
            certificateURL: 'https://www.bvapps.es/fairplaySafari.cer',
            prepareContentId: function(contentId) {
              var uri = contentId;
              var uriParts = uri.split('://', 1);
              var protocol = uriParts[0].slice(-3);
              uriParts = uri.split(';', 2);
              contentId = uriParts.length > 1 ? uriParts[1] : '';
              uriParts = contentId.split('?', 2);
              contentId = uriParts.length > 1 ? uriParts[0] : contentId;
              return protocol.toLowerCase() == 'skd' ? contentId : '';
            },
            prepareLicenseAsync: function(ckc) {
              return new Promise(function(resolve, reject) {
                const reader = new FileReader();
                reader.addEventListener('loadend', function() {
                  resolve(new Uint8Array(reader.result));
                });
                reader.addEventListener('error', function() {
                  reject(reader.error);
                });
                reader.readAsArrayBuffer(ckc);
              });
            },
            prepareMessage: function(event, session) {
              return new Blob([event.message], {type: 'application/octet-binary'});
            },
            headers: [{
              name: 'content-type',
              value: 'application/octet-stream'
            }],
            useUint16InitData: true,
            licenseResponseType: 'blob'
          }
        }
      }

      console.log(source)

      if (this.$route.query.vr) {
        source.vr = {
          startupMode: '2d',
          // startPosition: 180
          startPosition: 0,
          contentType: 'tab',
          initialRotation: 'true',
          initialRotateRate: 0.25
        }
        delete source.drm
      }

      this.modalData.video = {...this.modalData.video, ...config.source}
      
      console.log('Video', '**********************************************')
      console.log('Video', "bitmovin.player('player')")
      console.log('Video', document.querySelector('.wrapper'))
      let player = null
      player = new bitmovin.player(document.querySelector('.wrapper'), config);
      // console.log('Video', {player})
      // console.log('Video', '**********************************************')

      this.player = player
      this.setupInit = !!this.modalData && !!player
      if (!this.setupInit) return
      player.load(source).then((value) => {
        // Success
        clearInterval(this.pid)
        console.log('Video', 'Successfully created bitmovin player instance');
        var session = {
          program_slug: this.modalData.slug,
          user_id: user.uid,
          date: new Date().getTime(),
          duration: 0,
          device_id: this.$store.state.deviceId,
          ip: this.$store.state.ip,
          prefered_language_audio: 'es',
          prefered_language_subtitulos: 'es'
        }
        this.session = session
        var ref = db.collection('log_video_views').doc()
        this.sessionRef = ref
        ref.set(this.session)
        player.play()

        const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)
        const referredUrl = location.protocol + '//' + location.host

      }).catch((reason) => {
        // Error!
        console.log('Video', {reason})
        //history.go(-1)
        //this.player.destroy()
        // document.querySelector('#player').innerHTML = ''
        //this.setupInit = null
        console.log('Video', 'Error while creating bitmovin player instance');
      });

      // EVENTS
      this.player.on(bitmovin.event.ON_PLAYING, () => {
        console.log('Video', 'player is playing', this.$store.getters.user)
        if (this.fromTimestamp) {
          this.fromTimestamp = false
          console.log('user', this.$store.getters.user, this.modalData)
          db.collection('users_videos_last_times')
            .doc(this.$store.getters.user.uid)
            .collection('videos')
            .doc(this.modalData.id || this.modalData.slug)
            .get().then((doc) => {
              var data = doc.data()
              console.log('Video', '{timestamp}', data)
              if (data && data.timestamp) {
                this.player.seek(data.timestamp)
              }
              this.log_video_views({
                event: this.first_play_event,
                program_slug: this.modalData.slug,
                duration: data.timestamp || 0
              })
              this.first_play_event = 'play'
            })
        } else {
          console.log('Video', Math.round(this.player.getCurrentTime()))
          this.log_video_views({
            event: this.first_play_event,
            program_slug: this.modalData.slug,
            duration: Math.round(this.player.getCurrentTime())
          })
          this.first_play_event = 'play'
          console.log('Video', bitmovin.event)
        }
      })

      this.player.on(bitmovin.event.ON_PAUSED, (ev) => {
        console.log('Video', '...pause...', ev)
        this.log_video_views({
          event: 'pause',
          program_slug: this.modalData.slug,
          duration: Math.round(this.player.getCurrentTime())
        })
        if (ev.issuer && ev.issuer.includes('ad')) {
          this.player.play()
        }
      })

      this.player.on(bitmovin.event.ON_DESTROY, async () => {
        console.log('Video', 'player destroyed')
        console.log('Video', 'session:', this.session)
        if (this.session) {
          const duration = (new Date().getTime()) - this.session.date
          console.log('Video', 'duration:', duration)
          console.log('Video', '[this.sessionRef]' ,this.sessionRef)
          await this.sessionRef.update({ duration: duration })
        } else {
          await this.sessionRef.update({ duration: Math.round(this.player.getCurrentTime()) })
        }
        console.log('Video', '..............')
      })

      // const adTagVastSkippable = ''
      // const adTagVast1 = ''
      // const adTagVast2 = "=deployment%3Ddevsite%26sample_ar%3Dpostonly&cmsid=496&vid=short_onecue&correlator="
      // this.player.ads.schedule({
      //   tag: {
      //     type: adTagVastSkippable
      //   },
      //   id: 'Ad-adTagVastSkippable'
      // });
      // this.player.ads.schedule({
      //   tag: {
      //     type: adTagVast1
      //   },
      //   id: 'Ad-adTagVast1'
      // });
      // this.player.ads.schedule({
      //   tag: {
      //     type: adTagVast2
      //   },
      //   id: 'Ad-adTagVast2'
      // });


    },
    async init () {
      this.startActiveUser()
      this.setVideoBack(true)
      clearInterval(this.pid)
      this.pid = setInterval(() => {
        if (this.modalData && this.modalData.slug === this.$route.params.slug) {
          this.setup()
        }
      }, 1000)
      console.log('Video', 'PID', this.pid)
    },
    startActiveUser() {
      clearInterval(this.activePid)
      this.doActiveTick()
      this.activePid = setInterval(() => {
        this.doActiveTick()
      }, 300000)
    },
    doActiveTick() {
      console.log('Video', '**************(TICK ACTIVE USER)**************')
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .set({
        lastPlay: new Date().getTime()
      })
    },
    removeActiveUser() {
      clearInterval(this.activePid)
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .delete()
    },
    async beforeExit() {
      this.setVideoBack(false)
      console.log('beforeExit:Video', '<beforeRouteLeave>')
      console.log('beforeExit:Video', 'player destroy', this. player)
      clearInterval(this.pid)
      this.removeActiveUser()
      this.setupInit = null
      // const id = this.modalData.id
      
      if (this.player) {
        console.log('Video', 'player destroy')
        const allTime = this.player.getDuration()
        var current = this.player.getCurrentTime()

        console.log('beforeExit:Video', this.modalData.id, {allTime, current})
        console.log('beforeExit:Video', 'this.$store.getters.user.uid: ', this.$store.getters.user.uid)
        console.log('beforeExit:Video', this.modalData)
        // db.collection('users_videos_last_times')
        //   .doc(this.$store.getters.user.uid)
        //   .collection('videos')
        //   .doc(this.modalData.slug).set({
        //     id: this.modalData.id,
        //     timestamp: current,
        //     duration: allTime,
        //     progress: 100 * (current || 0) / (allTime || 1)
        //   }, { merge: true })
        //
        console.log('beforeExit:set?', `users_videos_last_times/${this.$store.getters.user.uid}/videos/${this.modalData.slug}`)
        try {
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}`).set({
            updated_at: new Date()
          })
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}/videos/${this.modalData.id}`).set({
            id: this.modalData.id,
            slug: this.modalData.slug,
            timestamp: current,
            duration: allTime,
            progress: 100 * (current || 0) / (allTime || 1),
            user_id: this.$store.getters.user.uid
          }, { merge: true })
        } catch(error) {
          console.error(error)
        }

        this.player.destroy()
        // const duration = (new Date().getTime()) - this.session.date
        // this.sessionRef.update({duration: duration})
      } 
      // console.log('Video', {to}, to.name)
      try {
      this.log_video_views({
        event: 'exit',
        program_slug: this.modalData.slug,
        duration: Math.round(this.player ? this.player.getCurrentTime() : 0)
      })
      } catch(error) {console.error(error)}
      this.modalData = null
    }
  },
  watch: {
    program () {
      console.log('Video', '--WATCH--', 'program')
      this.modalData = this.program
      // this.init()
    },
    async '$route' (to, from, other) {
      console.log('Video', '--WATCH--', 'route')
      console.log('Video', 'NAME-ID', to.name, to.params)
      if (to.name === 'Video' && to.params.id) {
        this.fromTimestamp = this.$route.query.timestamp
        await this.getProgram(this.$route.params.id)
        this.modalData = this.program
        this.init()
      } else if (to.name === 'Video' && to.params.slug) {
        this.fromTimestamp = this.$route.query.timestamp
        await this.getProgramBySlug(this.$route.params.slug)
        this.modalData = this.program
        this.init()
      }
    },
    // userData () {
    //   console.log('Video', '--WATCH--', 'userData')
    //   this.setup()
    // }
  },
  // async beforeRouteUpdate (to, from, next) {
  //   console.log('Video', '<beforeRouteUpdate>')
  //   this.fromTimestamp = this.$route.query.timestamp
  //   await this.getProgram(this.$route.params.id)
  //   if (!this.modalData) {
  //     this.modalData = this.program
  //     this.modalData && this.setup()
  //   }
  //   next()
  // },
  beforeRouteLeave (to, from, next) {
    this.beforeExit()
    console.log('Video', '[NEXT]')
    next()
  }
}
</script>
<style scoped>
.wrapper {
  background: black;
  width: 100%;
  height: calc(100vh - 64px);
}
.player {
  width: 100%;
  height: 100%;
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}
</style>
<style>
/*.bmpui-ui-playbacktoggle-overlay {
  opacity: 0;
}
.bmpui-player-state-playing .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-hidden .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-shown .bmpui-ui-playbacktoggle-overlay {
  opacity: 1 !important;
}*/
.bmpui-ui-watermark {
  display: none;
}
</style>
